import React from 'react'
import './Tags.scss'
import Barcode from '../../components/Barcode'

export default class Tags extends React.PureComponent {
    styles = {}

    render() {
        if (!this.props.products) return
        function stoneSizes(product) {
            const hasStoneSizes = product.center_stone || product.side_stones ? true : false
            if (hasStoneSizes)
                return (
                    <div className='stone-sizes'>
                        <div>C: {product.center_stone || ''}</div>
                        <div>S: {product.side_stones || ''}</div>
                    </div>
                )
        }

        function getTagClassName(products, index) {
            let tagClassName = ['tag']

            index === 0 && tagClassName.push('first')
            index % 2 !== 0 && tagClassName.push('second')
            index === products.length - 1 && tagClassName.push('last')
            tagClassName = tagClassName.join(' ')

            return tagClassName
        }

        return (
            <div className='tags'>
                {this.props.products.map((product, index) => (
                    <div key={index} className={getTagClassName(this.props.products, index)}>
                        <div className='left'>
                            {/* PRICE AND METAL */}
                            <div className='top'>
                                <div>{product.price}</div>
                                <div>{product.metal && product.metal}</div>
                            </div>
                            <div className='bottom'>
                                {/* GEMSTONES */}
                                {product.gemstones && <div>{product.gemstones}</div>}
                                {/* STONE SIZES */}
                                {stoneSizes(product)}
                                {/* BAND WIDTH */}
                                {/* Boolean(): a bare `value &&` renders the number 0 onto the
                                    printed tag when the field is zero (0 is falsy but is still a
                                    valid React child). */}
                                {Boolean(product.band_width) && (!product.gemstones || !stoneSizes(product)) && (
                                    <div>{product.band_width} mm</div>
                                )}
                                {/* Ring Size */}
                                {Boolean(product.ring_size) && (!product.gemstones || !stoneSizes(product)) && (
                                    <div>Size {product.ring_size}</div>
                                )}
                                {/* LENGTH */}
                                {product.length > 0 && <div>{product.length} in.</div>}
                                {/* WATCH MODEL */}
                                {product.watch_model && <div>{product.watch_model}</div>}
                            </div>
                        </div>
                        {/* BARCODE */}
                        <div className='right'>
                            <Barcode
                                className='barcode'
                                options={{
                                    width: 0.8,
                                    height: 22,
                                    fontSize: 8.3,
                                    margin: 0,
                                    marginTop: 2,
                                    font: 'Open Sans',
                                    fontOptions: 'bold'
                                }}
                                value={product.barcode}
                            />
                        </div>
                    </div>
                ))}
            </div>
        )
    }
}
